'use strict';

// Move other rp:* keys here so it's all in one place
module.exports = Object.freeze({
	GARAGE_V1: 'rp:garage:v1',
	SUPPLIER_V1: 'rp:supplier:v1',
	USER_ZIP_CODE: 'user_zip_code',
});
